export const CONTRACT_VERSION = "2026-1";

export const CONTRACT_TITLE = "Residential Snow Removal Service Agreement";
export const CONTRACT_LAST_UPDATED = "2026";

export const CONTRACT_INTRO =
  "By completing your purchase online, you (\u201CClient\u201D) agree to the following Terms and Conditions with Capital Shield (\u201CCompany\u201D) for residential snow removal services during the 2026\u20132027 Winter Season (November 1, 2026 \u2013 April 15, 2027).";

export const CONTRACT_SECTIONS = [
  {
    heading: "1. Scope of Services",
    points: [
      ["Service Period", "Services are active from November 1, 2026, through April 15, 2027."],
      ["Service Trigger", "Automatic dispatch occurs when single-storm snow accumulation reaches 5 cm or more as officially recorded."],
      ["City Plow Windrows", "Standard service includes return visits to clear the snow ridge (windrow) left at the end of the driveway by municipal street plows."],
      ["Dispatch Notifications", "Automated text (SMS) notifications will be sent to the mobile phone number provided at checkout when crews are en route."],
      ["Selected Add-Ons", "Optional services (e.g., Walkways/Steps, Garage Hand-Finish, Extra Vehicle Pads, Salting/Sanding) will only be rendered if selected and paid for during online checkout."],
    ],
  },
  {
    heading: "2. Exclusions & Limitations",
    points: [
      ["Minor Snowfall & Drifting", "Services are not provided for snowfalls under 5 cm, wind-drifted snow, or ice accumulation."],
      ["Clearance Buffer Zones", "Standard tractor/plow equipment will clear up to 15 cm from driveway markers and 61 cm from garage doors/structures. Clearing closer than 61 cm to garage doors requires the purchase of the Hand-Finish Add-On."],
      ["Seasonal Accumulation Cap", "Contract rates cover cumulative seasonal snowfall up to 300 cm (measured at the Ottawa Airport via Environment Canada). Total seasonal snowfall exceeding 300 cm will be billed at an additional 5% of the total contract value per additional storm."],
    ],
  },
  {
    heading: "3. Client Responsibilities & Preparation",
    points: [
      ["Driveway Obstructions", "All vehicles, portable basketball hoops, extension cords, toys, and debris must be moved off the driveway prior to crew arrival. Capital Shield is not responsible for missed service or delays caused by blocked driveways."],
      ["Driveway Markers", "Client agrees to allow Capital Shield to install driveway markers for equipment guidance. Markers must remain in place for the entire season."],
      ["Property Hazards", "Client must notify Capital Shield prior to the start of the season of any hidden hazards, low-hanging wires, uneven stone/paving, or fragile features near the clearance zone."],
    ],
  },
  {
    heading: "4. Liability & Property Damage",
    points: [
      ["Insurance & Permits", "Capital Shield carries $2M Commercial General Liability Insurance and maintains a valid City of Ottawa Snow Removal Permit."],
      ["Pre-Existing Conditions", "Capital Shield is not liable for pre-existing damage to driveways, curbs, lawns, or structures."],
      ["Ice & Slip Hazards", "Snow removal does not guarantee an ice-free surface. Capital Shield is not liable for slip-and-fall accidents, freezing rain, or natural ice buildup unless explicit Salting & Sanding services are purchased."],
    ],
  },
  {
    heading: "5. Payment & Cancellations",
    points: [
      ["Payment", "Full payment or approved payment-plan agreement is required prior to service activation."],
      ["Late Signups", "Registrations completed after November 15 are subject to a standard $75 late administrative fee."],
      ["Non-Refundable", "Seasonal contracts represent a reserved route slot out of a limited route capacity. Seasonal fees are non-refundable once the service period begins on November 1."],
    ],
  },
];

export const CONTRACT_ACK =
  "By checking the \u201CI agree to the Terms & Conditions\u201D box and completing checkout, you acknowledge that you have read, understood, and agree to be bound by all terms outlined above with Capital Shield.";
